import { Component, Prop } from "vue-property-decorator";
import { VueBase } from "../../Controls/VueBase";
import { ParametresInstance } from "../../Controls/Parameters";

@Component
export default class FiltreDrop extends VueBase {
	@Prop()
	public columns: any;

	public listeParam?;

	public mounted(): void {
		console.log("A");

		switch (this.columns.Filter.Values) {
			case "CLASI":
				console.log("B");
				this.listeParam = ParametresInstance.listeParametres;
				break;
			case "MONTH":
				console.log("C");
				this.listeParam = ParametresInstance.listeMois;
				break;
		}

		console.log(this.listeParam);
		this.$forceUpdate();
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/FiltreDrop/FiltreDrop.ts